import React from 'react';
import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSmall from '../../components/Footers/FooterSmall.js';
import RegisterComponent from '../../components/Auth/register';
import Head from 'next/head';

export default function Auth() {
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link rel="canonical" href="https://musicart.io/auth/register" />
      </Head>

      <Navbar transparent />
      <main className="main auth_bg">
        <RegisterComponent />
      </main>
      <Footer />
      <FooterSmall />
    </>
  );
}
